module.exports = __webpack_public_path__ + "img/Free Response 03.c0f11f98.png";